import React from 'react';

import { Box, Tooltip } from '@mui/material';

import type { HealthResult, TimelineHealth } from '~/utils/projectTasks';

const HEALTH_COLORS: Record<TimelineHealth, string> = {
  red: 'error.main',
  amber: 'warning.main',
  green: 'success.main',
};

interface Props {
  result: HealthResult;
}

export default function HealthDot({ result }: Props) {
  const { health, reason } = result;

  return (
    <Tooltip title={reason}>
      <Box
        aria-label={reason}
        role="img"
        tabIndex={0}
        sx={{ bgcolor: HEALTH_COLORS[health], borderRadius: '50%', height: 10, mx: 'auto', width: 10 }}
      />
    </Tooltip>
  );
}
